import { inject, Injectable, signal } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { UserArea } from '../models/user-area';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly msal = inject(MsalService);

  username = signal<string | null>(null);
  useremail = signal<string | null>(null);
  userphoto = signal<string | null>(null);
  roles = signal<string[]>([]);
  areas = signal<UserArea[]>([]);

  setUser(name: string, email: string) {
    this.username.set(name);
    this.useremail.set(email);
  }

  async fetchPhoto() {
    try {
      const scopes: string[] = ['User.Read'];
      const account = this.msal.instance.getAllAccounts()[0];

      if (!account) {
        this.userphoto.set(null);
        return;
      }

      const silentResult = await this.msal.instance.acquireTokenSilent({ scopes, account });
      const res = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: { Authorization: `Bearer ${silentResult.accessToken}` },
      });

      if (res.status === 404) {
        this.userphoto.set(null);
        return;
      }

      if (!res.ok) {
        throw new Error(`Graph error ${res.status}`);
      }

      const blob = await res.blob();
      this.userphoto.set(URL.createObjectURL(blob));
    } catch (error) {
      console.warn('Unable to load user photo', error);
      this.userphoto.set(null);
    }
  }

  setRoles(userRoles: string[]) {
    const AREA_PREFIX = 'CHECKLISTS_';
    const roles = userRoles.filter((r) => !r.startsWith(AREA_PREFIX));
    this.roles.set(roles);
  }

  hasRole(role: string): boolean {
    return this.roles().includes(role);
  }

  setAreas(areas: UserArea[]) {
    this.areas.set(areas);
  }
}
